/**
 * Centralized z-index scale.
 *
 * Usage: import { Z } from '@/lib/z-index'
 *        className={`fixed ${Z.SIDEBAR}`}
 *
 * Layer order (bottom → top):
 *   DROPDOWN  (30) — popover, select, tooltip, dropdown menu
 *   SIDEBAR   (40) — admin sidebar, navigation
 *   DRAWER    (50) — cart drawer backdrop + panel
 *   OVERLAY   (60) — modal backdrop + container + dialog (same z, DOM order stacks them)
 *   OVERLAY_POPOVER (70) — popovers/calendars opened from inside a modal/dialog
 *   TOAST     (80) — toast notifications (sonner)
 *
 * IMPORTANT: Modal backdrop and container MUST share the same z-index.
 * DOM order ensures container renders above backdrop. Using different
 * z-indices causes stacking context issues with position:fixed elements.
 */
export const Z = {
  DROPDOWN: 'z-30',
  SIDEBAR:  'z-40',
  DRAWER:   'z-50',
  OVERLAY:  'z-[60]',
  OVERLAY_POPOVER: 'z-[70]',
  TOAST:    'z-[80]',
} as const;
